// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__ob2Fw","modalWindow":"styles_modalWindow__y6P7Y","svg":"styles_svg__i9wAY","show":"styles_show__3kdTG"};